import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { Table } from "melco-ui";
import { Key, useEffect } from "react";
import { QueryObserverResult } from "react-query";
import { useTableSelection } from "../../../hooks/table/useTableSelection";
import { IdentityMelcoAnalyticsModelsWidgetListItem } from "melco-shared-logic";
import { AddRemoveWizardButton } from "../AddRemoveWizardButton";
import { useAddRemoveWizards } from "../../../hooks/dashboard/useAddRemoveWizard";
import { useGetAllWizards } from "../../../hooks/dashboard/useGetAllWizards";

type UsersWizardsDrawerProps = {
  referencesUserWizardDrawer: DrawerType;
  refetch?: () => Promise<QueryObserverResult<any, unknown>>;
  onSelectUserWizardByUser?: (v: string) => void;
  onCloseUsersWizardsDrawer: () => void;
};

export const UsersWizardsDrawer: React.FC<UsersWizardsDrawerProps> = ({
  onCloseUsersWizardsDrawer,
  referencesUserWizardDrawer,
}) => {
  const { t } = useTranslation();

  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    //pagination,
    //filtersChange,
  } = useGetAllWizards();

  const { wizards } = useAddRemoveWizards();
  const { isDrawerOpen } = referencesUserWizardDrawer;
  const activeUserWizardList = wizards ?? undefined;

  useEffect(() => {
    const arr: Key[] = [];
    activeUserWizardList?.map((p: any) => {
      arr.push(p?.code ?? undefined);
    });
    setSelectedRows(wizards);
    setSelectedRowKeys(arr);
  }, [activeUserWizardList]);

  const columns = [
    {
      title: t("dashboard.wizards.table.column.wizard"),
      key: "name",
      dataIndex: "name",
      sorter: true,
      width: "100%",
    },
  ];

  const {
    setSelectedRows,
    selectedRows,
    setSelectedRowKeys,
    rowSelection,
    onRow,
  } = useTableSelection<IdentityMelcoAnalyticsModelsWidgetListItem>(() => { }, {
    fixed: "left",
  });

  return (
    <Drawer
      title={t("dashboard.wizards.drawer_title")}
      placement="right"
      width={700}
      closable={true}
      onClose={onCloseUsersWizardsDrawer}
      open={isDrawerOpen}
      bodyStyle={{ padding: 10 }}
      destroyOnClose={true}
      forceRender={true}
    >
      <Table
        showSorterTooltip={false}
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        rowKey="code"
        rowSelection={rowSelection}
        onRow={onRow}
        noDataMessage={t("dashboard.wizards.table.no_data_message")}
        errorComponent={errorComponent}
      />

      <AddRemoveWizardButton
        selectedRows={selectedRows}
        callback={onCloseUsersWizardsDrawer}
      />
    </Drawer>
  );
};
